import { styled } from '@linaria/react';

import { colors, fonts, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[3]};
`;

export const HeaderTitle = styled.h3`
  font-family: ${fonts.heading};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.medium};
  color: ${colors.fontPrimary};
  margin: 0;
`;

export const SignInButtonWrapper = styled.div`
  flex-shrink: 0;
`;

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
`;

export const SplitRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;

  & > :first-child {
    padding-right: ${space[4]};
    border-right: 1px solid ${colors.borderGreyLighter};
  }

  & > :last-child {
    padding-left: ${space[4]};
  }
`;

export const PhoneFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[1]};
`;

export const SubheadingLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  color: ${colors.fontPrimary};
`;
